import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'MyDocUploads';

/**
 * Per-page meta for the public pages (CSR-rendered; prerendering the marketing
 * routes is a flagged follow-up for full crawler coverage).
 */
export default function Seo({ title, description, canonicalPath, image, type = 'website' }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : SITE_NAME;
  const canonical =
    canonicalPath && typeof window !== 'undefined'
      ? `${window.location.origin}${canonicalPath}`
      : undefined;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {canonical && <meta property="og:url" content={canonical} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
    </Helmet>
  );
}
